import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Link, Notification } from 'base-ui'

import {
  CONTACT_FORM_SUBJECT_KEY,
  directContactFormSubjectCatalogGetValue,
} from '../../model/directContactFormSubjectCatalog'

export const DirectContactFormDoctorOrderNotification: FC<{
  isLoggedIn: boolean
}> = ({ isLoggedIn }) => {
  const intl = useIntl()

  const emailAddress = intl.formatMessage({
    id: 'contactForm.label.email.invitation.email',
  })

  const emailSubject = directContactFormSubjectCatalogGetValue(
    intl,
    CONTACT_FORM_SUBJECT_KEY.DOCTOR_ORDER,
  )

  const link = (text: ReactNode[]): ReactElement => (
    <Link
      className="font-medium text-dark-primary-max"
      href={`mailto:${emailAddress}?subject=${emailSubject}`}
    >
      {text}
    </Link>
  )

  const shouldShowBody = !isLoggedIn

  return (
    <Notification
      className="mt-3 space-y-2"
      data-qa-id="contact-doctor-order-notification"
      icon
      severity="info"
      title={intl.formatMessage({
        id: 'erxFamily.benefits.security.title',
      })}
    >
      <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.header" />
      <ul className="my-2 list-outside list-disc pl-6">
        <li>
          <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.list.firstItem" />
        </li>
        <li>
          <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.list.secondItem" />
        </li>
      </ul>
      <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.subheader" />
      <ul className="my-2 list-outside list-disc pl-6">
        <li>
          {shouldShowBody ? (
            <FormattedMessage
              id="direct.contact.form.pharma.doctor.order.notification.body"
              values={{ link }}
            />
          ) : (
            <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.list.thirdItem" />
          )}
        </li>
        <li>
          <FormattedMessage id="direct.contact.form.pharma.doctor.order.notification.list.fourthItem" />
        </li>
      </ul>
    </Notification>
  )
}
